<template>
  <table-report
      v-on="$listeners"
      v-if="!settings.loading"
      :settings="settings.tableData"
      :partner="partner"
      @page-change="helper.runSubreport(settings, $event)"
      @exp-callback="helper.exportSubreport(settings)"
      :export-settings="settings.exportData"
      @row-clicked="helper.rowClicked(settings, $event)"
	  @selected-for-edit="helper.rowSelected(settings, $event)"
      :massive-actions="massiveActions"
  ></table-report>

  <div v-else class="w-100">
    <v-progress-circular
        indeterminate
        color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
import TableReport from "./tableReport";
export default {
  name: 'TableReportWr',
  components: {
    TableReport,
  },
  props: {
    settings: {
      type: Object,
      required: true
    },
    helper: {
      type: Object,
      required: true
    },
    partner: {
      type: Object,
      required: false
    },
    massiveActions: {
		type: Array,
		required: false
	}
  },
   
}
</script>
